import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ThemeService } from '../../services/theme.service';
import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'lib-skeleton-table-loader',
    imports: [NgxSkeletonLoaderModule],
    standalone: true,
    template: `

        <div class="skeleton-table">
            <!-- Subtitle -->
            <div>
                <ngx-skeleton-loader appearance="line" count="1"
                    [animation]="theme() === 'dark-theme' ? 'progress-dark' : 'progress'" [theme]="theme() === 'dark-theme' ? {
                        height: '19px',
                        width: '26rem',
                        'background-color': 'rgb(48 48 48)',
                    } : { height: '32px', width: '26rem' }" />
            </div>

            <!-- Filter input -->
            <ngx-skeleton-loader appearance="line" count="1"
                [animation]="theme() === 'dark-theme' ? 'progress-dark' : 'progress'" [theme]="theme() === 'dark-theme' ? {
                    height: '56px',
                    'background-color': 'rgb(48 48 48)',
                } : { height: '56px' }" />

            <!-- Table headers -->
            <div class="mt-2 flexed-space">
                <ngx-skeleton-loader appearance="line" count="6"
                    [animation]="theme() === 'dark-theme' ? 'progress-dark' : 'progress'" [theme]="theme() === 'dark-theme' ? {
                        height: '52px',
                        width: '9rem',
                        'background-color': 'rgb(48 48 48)',
                        display: 'flex',
                    } : { height: '52px', width: '9rem', }" />
            </div>

            <!-- Table data rows -->
            <div class="px-3">
                <ngx-skeleton-loader appearance="line" count="3"
                    [animation]="theme() === 'dark-theme' ? 'progress-dark' : 'progress'" [theme]="theme() === 'dark-theme' ? {
                        height: '52px',
                        'background-color': 'rgb(48 48 48)',
                    } : { height: '52px' }" />
            </div>

            <!-- Pagination -->
            <div class="flex-end">
                <ngx-skeleton-loader appearance="line" count="1"
                    [animation]="theme() === 'dark-theme' ? 'progress-dark' : 'progress'" [theme]="theme() === 'dark-theme' ? {
                        height: '56px',
                        width: '23rem',
                        'background-color': 'rgb(48 48 48)',
                    } : { height: '56px', width: '23rem' }" />
            </div>

        </div>

    `,
    styles: [`
        .skeleton-table {
            padding: 0 1rem 1rem 1rem;
            margin-top: 1rem;

            .flexed-space {
                display: flex;
                flex-direction: column;

                ngx-skeleton-loader {
                display: inherit;
                justify-content: space-between;
                padding: 0 1rem;
                }
            }

            .flex-end {
                display: flex;
                justify-content: flex-end;

                ngx-skeleton-loader {
                display: inherit;
                // padding: 0 1rem;
                }
            }


            @media (max-width: 524px) {
                margin: 0;
                padding: 0;

                .flex-end {
                    justify-content: center;
                    margin-top: 1rem;
                }
            }
        }
    `]
})
export class SkeletonTableLoaderComponent {
    private readonly _themeService = inject(ThemeService);
    protected readonly theme = toSignal(this._themeService.themeChange$);
}
